import { logEvent } from './analyticsUtils';
import { FEATURE_TYPES } from '../constants';

const ugcAnalytics = () => {

  const ANALYTICS_EVENTS = {    
    WaypointStarted: 'started_waypoint',
    WaypointCreated: 'save_waypoint',
    WaypointUpdated: 'updated_waypoint',
    WaypointDeleted: 'deleted_waypoint',
    WaypointEnabled: 'enabled_waypoint',
    WaypointDisabled: 'disabled_waypoint',

    LineStarted: 'started_line',
    LineCreated: 'save_line',
    LineUpdated: 'updated_line',
    LineDeleted: 'deleted_line',
    LineEnabled: 'enabled_line',
    LineDisabled: 'disabled_line',

    AreaStarted: 'started_area',
    AreaCreated: 'save_area',
    AreaUpdated: 'updated_area',
    AreaDeleted: 'deleted_area',
    AreaEnabled: 'enabled_area',
    AreaDisabled: 'disabled_area',
    
    UploadPhoto: 'upload_photo',

    BulkEditStart: 'bulk_edit_start',
  };
  
  const logWaypointStarted = () => {
    logEvent(ANALYTICS_EVENTS.WaypointStarted);
  };

  const logLineStarted = () => {
    logEvent(ANALYTICS_EVENTS.LineStarted);
  };

  const logAreaStarted = () => {
    logEvent(ANALYTICS_EVENTS.AreaStarted);
  };

  const getCreateFeatureEventData = (feature) => {
    return {
      created: feature.properties.createdAt,
      featureId: feature.uuid,
      location: feature.geometry.coordinates,
      state: feature.properties.states,
      userId: feature.properties.userUuid
    };
  };

  const logCreateFeature = (feature) => {
    let eventName = null;

    if (feature.properties.ghType === FEATURE_TYPES.Point) {
      eventName = ANALYTICS_EVENTS.WaypointCreated;
    }
    else if (feature.properties.ghType === FEATURE_TYPES.Polyline) {
      eventName = ANALYTICS_EVENTS.LineCreated;
    }
    else if (feature.properties.ghType === FEATURE_TYPES.Polygon) {
      eventName = ANALYTICS_EVENTS.AreaCreated;
    }

    if (eventName) {
      logEvent(eventName, getCreateFeatureEventData(feature));
    }
  };

  const logVisibility = (visibility, feature) => {
    let eventName = null;
    const eventData = {
      user_id: feature.userUuid,
      ugc_id: feature.uuid,
      ugc_name: feature.title,
    };

    if (feature.properties.type == FEATURE_TYPES.Point) {
      if ( visibility ) {
        eventName = ANALYTICS_EVENTS.WaypointEnabled;
      }
      else {
        eventName = ANALYTICS_EVENTS.WaypointDisabled;
      }
    }
    else if (feature.properties.type == FEATURE_TYPES.Polyline) {
      if ( visibility ) {
        eventName = ANALYTICS_EVENTS.LineEnabled;
      }
      else {
        eventName = ANALYTICS_EVENTS.LineDisabled;
      }
    }
    else if (feature.properties.type === FEATURE_TYPES.Polygon) {
      if ( visibility ) {
        eventName = ANALYTICS_EVENTS.AreaEnabled;
      }
      else {
        eventName = ANALYTICS_EVENTS.AreaDisabled;
      }
    }

    if ( eventName ) {
      logEvent(eventName, eventData);
    }
  };

  const logUpdateFeature = (feature) => {
    let eventName = null;
    let eventData = {
      user_id: feature.properties.userUuid,
      ugc_id: feature.uuid,
      ugc_name: feature.title,
      ugc_photos_count: feature.photoIds ? feature.photoIds.length : 0,
      ugc_notes: (feature.notes && feature.notes[0] && feature.notes[0].content) ? feature.notes[0].content : '',
      ugc_states: feature.properties.states,
      ugc_created: feature.properties.createdAt,
      ugc_updated: feature.properties.updatedAt,
      ugc_location: feature.geometry.coordinates,
      ugc_style_color: feature.properties.color,
    };

    if (feature.properties.type == FEATURE_TYPES.Point) {
      eventName = ANALYTICS_EVENTS.WaypointUpdated;
      eventData = {
        ...eventData,
        ugc_style_type: feature.properties.icon,
      };
    }
    else if (feature.properties.type == FEATURE_TYPES.Polyline) {
      eventName = ANALYTICS_EVENTS.LineUpdated;
      eventData = {
        ...eventData,
        ugc_style_type: feature.properties.strokeType,
        ugc_style_weight: feature.properties.strokeWidth,
      };
    }
    else if (feature.properties.type === FEATURE_TYPES.Polygon) {
      eventName = ANALYTICS_EVENTS.AreaUpdated;
      eventData = {
        ...eventData,
        ugc_style_type: feature.properties.strokeType,
        ugc_style_weight: feature.properties.strokeWidth,
      };
    }

    if ( eventName ) {
      logEvent(eventName, eventData);
    }
  };

  const logDeleteFeature = (feature) => {
    let eventName = null;
    const eventData = {
      user_id: feature.properties.userUuid,
      ugc_id: feature.uuid,
      ugc_name: feature.title,
    };

    if (feature.properties.type === FEATURE_TYPES.Point) {
      eventName = ANALYTICS_EVENTS.WaypointDeleted;
    }
    else if (feature.properties.type === FEATURE_TYPES.Polyline) {
      eventName = ANALYTICS_EVENTS.LineDeleted;
    }
    else if (feature.properties.type === FEATURE_TYPES.Polygon) {
      eventName = ANALYTICS_EVENTS.AreaDeleted;
    }

    if ( eventName ) {
      logEvent(eventName, eventData);
    }
  };

  const logUploadPhoto = (photoId) => {
    logEvent(ANALYTICS_EVENTS.UploadPhoto,{
      photoId
    });
  };

  const logBulkEditStart = () => {
    logEvent(ANALYTICS_EVENTS.BulkEditStart);
  };

  return {
    logWaypointStarted,
    logLineStarted,
    logAreaStarted,

    logCreateFeature,
    logUpdateFeature,
    logDeleteFeature,

    logVisibility,

    logUploadPhoto,
    
    logBulkEditStart,
  };
};

export default ugcAnalytics();